export default __webpack_public_path__ + "static/km-curriculum-777dec47aeab56c20ee5e4a3f220a590.jpeg";